import React, { useState } from 'react';

import useLastTerminatedInvoice from 'components/Common/VoluntaryBenefits/Hooks/useLastTerminatedInvoice';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import ExternalLink from 'components/Widgets/ExternalLink';

import { Button } from 'react-bootstrap5';

import WaitPaymentProcess from 'components/Members/Wallet/WaitPaymentProcess';
import currencyFormat from 'components/Widgets/currencyFormat';
import BuyModal from './BuyModal';

export default function ChangeEmailStep() {
  const invoice = useLastTerminatedInvoice();

  const [showBuyPopup, setShowBuyPopup] = useState(false);
  const [waitPayment, setWaitPayment] = useState(false);

  const closeModal = () => {
    setShowBuyPopup(false);
  };

  const onPayInvoice = () => {
    setShowBuyPopup(true);
  };

  if (invoice === null) {
    return (
      <div className="content pt-5 pb-5">
        <LoadingPlaceholder text="Loading..." />
      </div>
    );
  }

  if (invoice.id === null) {
    return <div />;
  }

  return (
    <>
      <h4>Step 2. Pay Your Balance</h4>
      <div className="mb-3 row mt-3">
        <div className="col-md-7">
          <dl className="row">
            <dt className="col-sm-4">Total Cost</dt>
            <dd className="col-sm-8">
              {
            currencyFormat(
              invoice.attributes.employee_total_cost,
              { currency: invoice.attributes.currency },
            )
}
            </dd>
            <dt className="col-sm-4">Fully Paid</dt>
            <dd className="col-sm-8">
              {
                currencyFormat(
                  invoice.attributes.total_paid,
                  { currency: invoice.attributes.currency },
                )
              }
            </dd>
          </dl>
          <hr className="col-md-6" />
          <dl className="row">
            <dt className="col-sm-4">Total</dt>
            <dd className="col-sm-8">
              {
                currencyFormat(
                  invoice.attributes.total,
                  { currency: invoice.attributes.currency },
                )
              }
            </dd>

          </dl>
        </div>
        <div className="col-md-5">
          <div className="d-flex flex-column gap-3">
            <Button onClick={onPayInvoice} className="ms-auto" style={{ width: '180px' }}>
              Pay Invoice
            </Button>
            <ExternalLink
              href={invoice.attributes.report_url}
              variant="outline-primary"
              className="ms-auto"
              style={{ width: '180px' }}
            >
              View Report
            </ExternalLink>

            <ExternalLink
              href={invoice.attributes.invoice_url}
              variant="outline-primary"
              className="ms-auto"
              style={{ width: '180px' }}
            >
              View Invoice
            </ExternalLink>
          </div>
        </div>
      </div>

      {waitPayment && <WaitPaymentProcess />}

      {showBuyPopup && (
      <BuyModal
        invoice={invoice}
        closeModal={closeModal}
        setWaitPayment={setWaitPayment}
      />
      )}

    </>
  );
}
